import React from 'react';

export const Container: React.FC<any> = (props) => {
  let classNames = 'container';
  if (props.className) {
    classNames += ` ${props.className}`;
  }

  return (
    <div className={classNames}>
      {props.children}
    </div>
  );
}
